import React from 'react'

const PageContainerContext = React.createContext()

export default PageContainerContext
